<!-- Notifications toggle -->
<button #notificationsOrigin (click)="openPanel()"
        *ngIf="organisationService.organisationId"
        class="notifications-toggle mat-flat-button bg-blue-100 mr-5"
        mat-icon-button>
  <mat-icon *ngIf="unreadCount > 0"
            [matBadge]="unreadCount"
  >notifications_active
  </mat-icon>
  <mat-icon *ngIf="(_notificationsService.notifications$ | async)?.length === 0"
            [svgIcon]="'feather:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

  <div class="notifications-panel">

    <div class="header">

      <div class="title">
        Notifications
        <ng-container *ngIf="(_notificationsService.notifications$ | async)?.length > 0">
          ({{(_notificationsService.notifications$ | async).length}})
        </ng-container>
      </div>

      <!--  <button (click)="markAllAsRead()"
                [matTooltip]="'Mark all as read'"
                class="mark-all-as-read"
                mat-icon-button>
          <mat-icon [svgIcon]="'playlist_add_check'"></mat-icon>
        </button>-->

    </div>

    <div class="content">

      <!-- Notifications -->
      <ng-container *ngFor="let notification of _notificationsService.notifications$ | async">

        <div [ngClass]="{'unread': !notification?.read}"
             class="notification">


          <!-- Notification without a link -->
          <span>
                        <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                    </span>

          <!-- Actions -->
          <div class="actions">

            <!-- Indicator -->
            <button
              [matTooltip]="notification?.read ? 'Mark as unread' : 'Mark as read'"
              class="indicator"
              mat-icon-button>
                            <span (click)="toggleRead(notification)" *ngIf="!notification?.read"
                                  class="unread"></span>
              <span (click)="toggleRead(notification)" *ngIf="notification?.read"
                    class="read"></span>
            </button>

            <!-- <button (click)="delete(notification)"
                     [matTooltip]="'Remove'"
                     class="remove"
                     mat-icon-button>
               <mat-icon [svgIcon]="'close'"></mat-icon>
             </button>-->

          </div>

        </div>

        <ng-template #notificationContent>

          <!-- Icon -->
          <!-- <mat-icon class="icon"
                     *ngIf="notification.icon && !notification.image"
                     [svgIcon]="notification.icon">
           </mat-icon>-->
          <mat-icon [svgIcon]="'inbox'"></mat-icon>

          <!-- Title, description & time -->
          <div class="notification-content">
            <!-- <div class="title"
                  *ngIf="notification.title"
                  [innerHTML]="notification.title"></div>-->
            <div *ngIf="notification.content"
                 [innerHTML]="notification.content"
                 class="description"></div>
            <div class="time">{{notification.createdOn | date:dateFormat}}</div>
          </div>

        </ng-template>

      </ng-container>

      <a (click)="onScroll()" *ngIf="(_notificationsService.notifications$ | async)?.length < totalRecords"
         class="float-right my-4 mx-2" href="javascript:void(0)"
         mat-stroked-button>Load more </a>
      <ng-container
        *ngIf="!(_notificationsService.notifications$ | async) || !(_notificationsService.notifications$ | async).length">
        <div class="empty">
          <mat-icon [svgIcon]="'notifications'"></mat-icon>
          <span>No notifications</span>
        </div>
      </ng-container>

    </div>

  </div>

</ng-template>
